import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import { values } from "lodash";
import React, { useContext } from "react";
import { BookingStatus } from "../pages/bookings/util";
import { getStyle } from "../utils";
import { StatusColorContext } from "./contexts";
import { translateStatus } from "./StatusField";

/** Status colour key shown below the booking calendar and kanban boards. */
const BookingStatusLegend: React.FC = () => {
  const { colors } = useContext(StatusColorContext);

  return (
    <Box
      className="booking-calendar-legend-panel"
      style={{
        border: "1px solid #ddd",
        borderRadius: "3px",
        padding: "10px",
      }}
    >
      <h2 style={{ marginTop: 0, marginBottom: 10 }}>Legend</h2>
      <Box className="booking-calendar-legend">
        {values(BookingStatus).map((status) => (
          <Chip
            key={status}
            label={translateStatus(status)}
            style={{
              ...getStyle(status, colors),
              minWidth: "100px",
              height: "30px",
              margin: "2px",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default BookingStatusLegend;
